// extracted by mini-css-extract-plugin
export default {"commentWrapper":"styles_commentWrapper__3wbX-","count":"styles_count__ADuBU","icon":"styles_icon__727p5","isUnread":"styles_isUnread__Y5GCl"};